import { useState, useEffect } from "react";
import t from "../translate";
import { TadsWidget, renderTadsWidget } from 'react-tads-widget';

const LinkButton = ({ onTap, value, actionValue, isConfirmVisible, onConfirm }) => {
  return (
    <div className="link-button">
      <img className="leading-icon" src="/assets/icons/ic_bookmark.svg" alt="ic_bookmark" />
      <h4 className="button-text" onClick={onTap}>
        {value}<strong>{actionValue}</strong>
      </h4>
      <div className="button-container">
        {isConfirmVisible ? (
          <button onClick={onConfirm} className="confirm-button">{t(localStorage.getItem('lang'), 'confirm')}</button>
        ) : (
          <img className="tale-icon" src="/assets/icons/ic_arrow_right.svg" alt="ic_arrow_right" />
        )}
      </div>
    </div>
  );
};

function loadAdSdkIfNotLoaded() {
  const scriptId = 'libtl.com';

  // Перевіряємо, чи скрипт вже є в DOM
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.src = '//munqu.com/sdk.js';
    script.dataset.zone = '9413380';
    script.dataset.sdk = 'show_9413380';
    script.id = scriptId;
    script.async = true;

    script.onload = () => {
      console.log('Ad SDK loaded successfully.');
      // можливо викликати функцію ініціалізації, якщо така є
    };

    script.onerror = () => {
      console.warn('Ad SDK failed to load.');
    };

    document.body.appendChild(script);
  } else {
    console.log('Ad SDK already loaded.');
  }
}

// Викликаємо після певної події або з затримкою
window.addEventListener('load', () => {
  setTimeout(loadAdSdkIfNotLoaded, 1000); // затримка 1 секунда після завантаження сторінки
});


const TaskComponent = ({ task, onTaskRemove }) => {
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [confirmedTasks, setConfirmedTasks] = useState([]);

  useEffect(() => {

    const savedConfirmedTasks = JSON.parse(localStorage.getItem('confirmedTasks')) || [];
    setConfirmedTasks(savedConfirmedTasks);
  }, []);

  const handleLinkButtonClick = () => {
    const updatedConfirmedTasks = [...confirmedTasks, task.signature];
    setConfirmedTasks(updatedConfirmedTasks);
    localStorage.setItem('confirmedTasks', JSON.stringify(updatedConfirmedTasks));

    if (task.signature === 'redirect_task') {
      try {
        loadAdSdkIfNotLoaded();

        // eslint-disable-next-line no-undef
        show_9413380('pop').then(() => {
        }).catch(e => {
        })
      } catch (error) {

      }
    } else if (task.signature === 'monetag_video') {
      // eslint-disable-next-line no-undef
      show_9413380()
        .then(() => {
        })
        .catch(() => {
        });
    }
    else if (task.signature === 'taddy' || task.signature === 'taddy_interstitial') {
      // eslint-disable-next-line no-undef
      const taddy = window && window.Taddy;
      if (!taddy || typeof taddy.ads !== 'function') {
        return;
      }
      const ads = taddy.ads();
      ads.interstitial({
        // можем добавить обработчик закрытия объявления
        onClosed: () => console.log('Объявление закрыто'),
        onViewThrough: (id) => console.log('Объявление просмотрено', id)
      }).then((success) => {
        // success содержит признак того, что объявление было показано
      });
    } else if (task.id) {
      try {
        const payload = {
          id: task.id,
          title: task.title || task.name || '',
          description: task.description || '',
          image: task.image || task.imageUrl || task.icon || '',
          link: task.link
        };
        window.dispatchEvent(new CustomEvent('openAdBoard', { detail: payload }));
      } catch (e) { }
    } else {
      window.open(task.link, '_blank', 'noopener,noreferrer');
    }

    setIsConfirmVisible(true);
  };

  const handleConfirmClick = (e) => {
    e.stopPropagation();

    console.log("Задача підтверджена");

    onTaskRemove(task.signature);

    const updatedConfirmedTasks = confirmedTasks.filter(id => id !== task.signature);
    setConfirmedTasks(updatedConfirmedTasks);
    localStorage.setItem('confirmedTasks', JSON.stringify(updatedConfirmedTasks));
    setIsConfirmVisible(false);
  };

  const isTaskConfirmed = confirmedTasks.includes(task.signature);

  useEffect(() => {
    if (isTaskConfirmed) {
      setIsConfirmVisible(true);
    }
  }, [isTaskConfirmed]);

  return (
    <div>
      <LinkButton
        onTap={handleLinkButtonClick}
        value={task.name}
        actionValue={task.actionValue}
        isConfirmVisible={isConfirmVisible}
        onConfirm={handleConfirmClick}
      />
    </div>
  );
};

export default TaskComponent;
